import { Author } from "@components/blog/Author";
import { BlogTypeAndDate } from "@components/blog/BlogTypeAndDate";
import Image from "next/image";
import { AuthorFrontMatter } from "types/AuthorFrontMatter";
import { PostFrontMatter } from "types/PostFrontMatter";
import HeroImage from "../../public/assets/documentary/laptop-hands-unsplash.jpg";

export const BlogPostHero = ({
  post,
  authors,
}: {
  post: PostFrontMatter;
  authors: AuthorFrontMatter[];
}) => {
  return (
    <div className="dark bg-black">
      <div className="h-240 w-full grow md:mx-0 md:hidden">
        <div className="relative h-full w-full">
          <Image
            src={post.thumbnail || HeroImage}
            alt=""
            layout="fill"
            objectFit="contain"
            priority
          />
        </div>
      </div>
      <div className="container-xl flex gap-32 py-32 md:gap-40 md:pt-[52px] md:pb-[52px]">
        <div className="flex flex-col justify-between gap-12 md:w-2/5 md:min-w-[380px] lg:min-w-[520px]">
          <BlogTypeAndDate type={post.type} date={post.date} />
          <h1 className="flex flex-col">
            <div className="flex flex-col gap-y-24">
              <h1 className="font-display text-32-36 text-gray-900 dark:text-white sm:text-56-56 ">
                {post.title}
              </h1>
              <div>
                {authors.map((author) => (
                  <Author key={author.name} author={author.name} />
                ))}
              </div>
            </div>
          </h1>
        </div>
        <div className="hidden min-h-[468px] w-full grow md:mx-0 md:block">
          <div className="relative h-full w-full">
            <Image
              src={post.thumbnail || HeroImage}
              alt=""
              layout="fill"
              objectFit="contain"
              objectPosition={"right"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
